/* Review-wall previews and privacy-enhanced YouTube playback. */
(function () {
  function initWall(wall) {
    if (wall.dataset.lvReviewsReady === 'true') return;
    wall.dataset.lvReviewsReady = 'true';

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      wall.lvPreviewObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              var promise = video.play();
              if (promise && promise.catch) promise.catch(function () {});
            } else video.pause();
          });
        },
        { rootMargin: '150px' }
      );
      wall.querySelectorAll('video.lv-video-tile__media').forEach(function (video) {
        wall.lvPreviewObserver.observe(video);
      });
    }

    function stopAll() {
      wall.querySelectorAll('[data-lv-player]').forEach(function (player) {
        player.replaceChildren();
        player.hidden = true;
      });
      wall.querySelectorAll('[data-lv-video-tile]').forEach(function (tile) {
        tile.hidden = false;
      });
    }

    wall.addEventListener('click', function (event) {
      var close = event.target.closest('[data-lv-player-close]');
      if (close && wall.contains(close)) {
        stopAll();
        return;
      }
      var tile = event.target.closest('[data-lv-video-tile]');
      if (!tile || !wall.contains(tile)) return;
      var youtubeId = tile.getAttribute('data-lv-youtube') || '';
      if (!/^[A-Za-z0-9_-]{6,20}$/.test(youtubeId)) return;
      event.preventDefault();
      var player = tile.parentElement.querySelector('[data-lv-player]');
      if (!player) return;
      stopAll();

      var frameWrap = document.createElement('div');
      frameWrap.className = 'lv-video-tile__frame-inner';
      var iframe = document.createElement('iframe');
      var embedUrl = new URL('https://www.youtube.com/embed/' + encodeURIComponent(youtubeId));
      embedUrl.searchParams.set('autoplay', '1');
      embedUrl.searchParams.set('playsinline', '1');
      embedUrl.searchParams.set('rel', '0');
      embedUrl.searchParams.set('origin', window.location.origin);
      embedUrl.searchParams.set('widget_referrer', window.location.href);
      iframe.src = embedUrl.toString();
      iframe.title = (tile.getAttribute('data-lv-name') || 'Customer') + ' video review';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      var closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'lv-video-tile__close';
      closeButton.setAttribute('data-lv-player-close', '');
      closeButton.setAttribute('aria-label', 'Close video');
      closeButton.textContent = '×';
      frameWrap.appendChild(iframe);
      player.appendChild(frameWrap);
      player.appendChild(closeButton);
      tile.hidden = true;
      player.hidden = false;
      closeButton.focus();
    });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-lv-reviews-wall]')) initWall(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-lv-reviews-wall]').forEach(initWall);
  }
  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var wall = event.target.querySelector && event.target.querySelector('[data-lv-reviews-wall]');
    if (wall && wall.lvPreviewObserver) wall.lvPreviewObserver.disconnect();
  });
})();
